<script>
import { mapGetters } from 'vuex';
import PhoneCredentialsAPI from 'dashboard/api/phoneCredentials';
import {
  UserAgent,
  Registerer,
  RegistererState,
  Inviter,
  SessionState,
} from 'sip.js';

export default {
  data() {
    return {
voipEnabled: false,
      // Botão flutuante
      x: null,
      y: null,
      dragging: false,
      moved: false,
      offsetX: 0,
      offsetY: 0,

      // Discador
      showDialer: false,
      showSettings: false,
      phoneNumber: '',

      dialerX: null,
      dialerY: null,
      dialerDragging: false,
      dialerOffsetX: 0,
      dialerOffsetY: 0,

      // Configuração SIP
      extension: '',
      agentName: '',
      sipServer: 'pbx.impulsotelecom.com.br',

      tempExtension: '',
      tempAgentName: '',
      tempSipServer: 'pbx.impulsotelecom.com.br',
      tempSipPassword: '',

      // SIP.js
      userAgent: null,
      registerer: null,
      currentSession: null,
      sipStatus: 'disconnected',
      callStatus: 'idle',
      incomingCall: false,
incomingNumber: '',
callStartedAt: null,
callDuration: 0,
callTimer: null,
    };
  },

  computed: {
...mapGetters({
    currentUser: 'getCurrentUser',
  }),
    sipStatusLabel() {
      if (this.sipStatus === 'connected') return 'Conectado';
      if (this.sipStatus === 'connecting') return 'Conectando...';
      if (this.sipStatus === 'error') return 'Erro';
      return 'Desconectado';
    },

    sipStatusSymbol() {
      if (this.sipStatus === 'connected') return '🟢';
      if (this.sipStatus === 'connecting') return '🟡';
      if (this.sipStatus === 'error') return '🔴';
      return '⚪';
    },

    callStatusLabel() {
      if (this.callStatus === 'calling') return 'Chamando...';
      if (this.callStatus === 'connected') return 'Em chamada';
      return '';
    },
  },
  watch: {
    currentUser: {
      async handler(user) {
        if (!user) {
          if (this.userAgent) {
            await this.disconnectSip();
          }

          return;
        }

        await this.loadPhoneCredentials();
      },
      deep: true,
    },
  },
  mounted() {
    const savedButton = localStorage.getItem(
      'impulso_phone_button_position'
    );

    if (savedButton) {
      const position = JSON.parse(savedButton);
      this.x = position.x;
      this.y = position.y;
    } else {
  this.x = Math.max(8, (window.innerWidth / 2) - 28);
  this.y = 0;
}

    const savedDialer = localStorage.getItem(
      'impulso_phone_dialer_position'
    );

    if (savedDialer) {
      const position = JSON.parse(savedDialer);
      this.dialerX = position.x;
      this.dialerY = position.y;
    }

    const savedSettings = localStorage.getItem(
      'impulso_phone_settings'
    );

    if (savedSettings) {
      const settings = JSON.parse(savedSettings);

      this.extension = settings.extension || '';
      this.agentName = settings.agentName || '';
      this.sipServer =
        settings.sipServer || 'pbx.impulsotelecom.com.br';
    }

    window.addEventListener('pointermove', this.onPointerMove);
    window.addEventListener('pointerup', this.onPointerUp);

    window.addEventListener(
      'pointermove',
      this.onDialerPointerMove
    );

    window.addEventListener(
      'pointerup',
      this.onDialerPointerUp
    );
if (this.currentUser) {
  this.loadPhoneCredentials();
} 
 },

  beforeUnmount() {
    window.removeEventListener('pointermove', this.onPointerMove);
    window.removeEventListener('pointerup', this.onPointerUp);

    window.removeEventListener(
      'pointermove',
      this.onDialerPointerMove
    );

    window.removeEventListener(
      'pointerup',
      this.onDialerPointerUp
    );
  },

  methods: {
async loadPhoneCredentials() {
  if (!this.currentUser) return;

  try {
    const response = await PhoneCredentialsAPI.getCredentials();
    const credentials = response.data;
this.voipEnabled = !!credentials.voip_enabled;

if (!this.voipEnabled) {
  if (this.userAgent) {
    await this.disconnectSip();
  }

  return;
}

    if (!credentials?.extension) {
      console.warn('Nenhum ramal vinculado a este usuário');
      return;
    }

    this.extension = credentials.extension;
    this.agentName =
      credentials.name || this.currentUser.name || '';

    this.sipServer =
      credentials.server || 'pbx.impulsotelecom.com.br';

    this.tempExtension = this.extension;
    this.tempAgentName = this.agentName;
    this.tempSipServer = this.sipServer;
   this.tempSipPassword = credentials.password || '';

if (
  this.tempSipPassword &&
  this.sipStatus !== 'connected'
) {
  await this.connectSip();
}

    console.log(
      'Ramal vinculado ao usuário:',
      this.extension
    );
  } catch (error) {
    console.error(
      'Erro ao carregar credenciais do telefone:',
      error
    );
  }
},
async disconnectSip() {
  try {
    if (this.currentSession) {
      try {
        if (
          this.currentSession.state ===
          SessionState.Established
        ) {
          await this.currentSession.bye();
        } else {
          await this.currentSession.cancel();
        }
      } catch {
        // sessão já encerrada
      }
    }

    if (this.registerer) {
      try {
        await this.registerer.unregister();
      } catch {
        // já desconectado
      }
    }

    if (this.userAgent) {
      try {
        await this.userAgent.stop();
      } catch {
        // ignora
      }
    }
  } finally {
    this.currentSession = null;
    this.registerer = null;
    this.userAgent = null;
    this.sipStatus = 'disconnected';
    this.callStatus = 'idle';
    this.incomingCall = false;
    this.incomingNumber = '';
    this.stopCallTimer();
  }
},
startCallTimer() {
  this.stopCallTimer();

  this.callStartedAt = Date.now();
  this.callDuration = 0;

  this.callTimer = setInterval(() => {
    this.callDuration = Math.floor(
      (Date.now() - this.callStartedAt) / 1000
    );
  }, 1000);
},

stopCallTimer() {
  if (this.callTimer) {
    clearInterval(this.callTimer);
    this.callTimer = null;
  }

  this.callStartedAt = null;
  this.callDuration = 0;
},

formatDuration(seconds) {
  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;

  return `${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
},

async answerIncomingCall() {
  if (!this.currentSession) return;

  try {
    await this.currentSession.accept({
      sessionDescriptionHandlerOptions: {
        constraints: {
          audio: true,
          video: false,
        },
      },
    });

    this.incomingCall = false;
this.showDialer = true;
    this.callStatus = 'connected';
    this.startCallTimer();
    this.setupRemoteMedia(this.currentSession);
  } catch (error) {
    console.error('Erro ao atender chamada:', error);
  }
},

async rejectIncomingCall() {
  if (!this.currentSession) return;

  try {
    await this.currentSession.reject();
  } catch (error) {
    console.error('Erro ao recusar chamada:', error);
  }

  this.incomingCall = false;
  this.incomingNumber = '';
  this.currentSession = null;
},
    // -------------------------
    // BOTÃO FLUTUANTE
    // -------------------------

    onPointerDown(event) {
      this.dragging = true;
      this.moved = false;

      this.offsetX = event.clientX - this.x;
     

      event.currentTarget.setPointerCapture?.(event.pointerId);
    },

onPointerMove(event) {
  if (!this.dragging) return;

  this.moved = true;

  const buttonSize = 56;
  const padding = 8;

  let newX = event.clientX - this.offsetX;

  newX = Math.max(
    padding,
    Math.min(
      window.innerWidth - buttonSize - padding,
      newX
    )
  );

  this.x = newX;

  // Sempre preso no topo
  this.y = 0;
},
onPointerUp() {
  if (!this.dragging) return;

  this.dragging = false;

  localStorage.setItem(
    'impulso_phone_button_position',
    JSON.stringify({
      x: this.x,
      y: 0,
    })
  );
},

    openDialer() {
      if (this.moved) {
        this.moved = false;
        return;
      }
this.showDialer = true;
     

      if (this.dialerX === null || this.dialerY === null) {
        this.dialerX = Math.max(
          10,
          Math.min(
            window.innerWidth - 300,
            this.x - 220
          )
        );

        this.dialerY = Math.max(
          10,
          Math.min(
            window.innerHeight - 560,
            this.y - 440
          )
        );
      }
    },

    closeDialer() {
      this.showSettings = false;
      this.showDialer = false;
    },

    // -------------------------
    // MOVIMENTAÇÃO DO DISCADOR
    // -------------------------

    onDialerPointerDown(event) {
      this.dialerDragging = true;

      const dialer = event.currentTarget.closest(
        '.impulso-dialer'
      );

      const rect = dialer.getBoundingClientRect();

      this.dialerOffsetX = event.clientX - rect.left;
      this.dialerOffsetY = event.clientY - rect.top;
    },

    onDialerPointerMove(event) {
      if (!this.dialerDragging) return;

      const width = 288;
      const height = 560;
      const padding = 8;

      let newX =
        event.clientX - this.dialerOffsetX;

      let newY =
        event.clientY - this.dialerOffsetY;

      newX = Math.max(
        padding,
        Math.min(
          window.innerWidth - width - padding,
          newX
        )
      );

      newY = Math.max(
        padding,
        Math.min(
          window.innerHeight - height - padding,
          newY
        )
      );

      this.dialerX = newX;
      this.dialerY = newY;
    },

onDialerPointerUp() {
  if (!this.dialerDragging) return;

  this.dialerDragging = false;

  localStorage.setItem(
    'impulso_phone_dialer_position',
    JSON.stringify({
      x: this.dialerX,
      y: this.dialerY,
    })
  );
},
  

    // -------------------------
    // TECLADO
    // -------------------------

    addDigit(digit) {
      this.phoneNumber += digit;
    },

    deleteDigit() {
      this.phoneNumber =
        this.phoneNumber.slice(0, -1);
    },

    clearNumber() {
      this.phoneNumber = '';
    },

    // -------------------------
    // CONFIGURAÇÃO
    // -------------------------

    openSettings() {
      this.tempExtension = this.extension;
      this.tempAgentName = this.agentName;
      this.tempSipServer = this.sipServer;
      this.tempSipPassword = '';
      this.showSettings = true;
    },

    closeSettings() {
      this.showSettings = false;
    },

    saveSettings() {
      this.extension = this.tempExtension.trim();
      this.agentName = this.tempAgentName.trim();
      this.sipServer = this.tempSipServer.trim();

      localStorage.setItem(
        'impulso_phone_settings',
        JSON.stringify({
          extension: this.extension,
          agentName: this.agentName,
          sipServer: this.sipServer,
        })
      );

      this.showSettings = false;
    },

    // -------------------------
    // REGISTRO SIP
    // -------------------------

    async connectSip() {
      if (
        !this.tempExtension ||
        !this.tempSipServer ||
        !this.tempSipPassword
      ) {
        this.sipStatus = 'error';
        return;
      }

      this.sipStatus = 'connecting';

      try {
        if (this.registerer) {
          try {
            await this.registerer.unregister();
          } catch {
            // ignora
          }
        }

        if (this.userAgent) {
          try {
            await this.userAgent.stop();
          } catch {
            // ignora
          }
        }

        const uri = UserAgent.makeURI(
          `sip:${this.tempExtension}@${this.tempSipServer}`
        );

        if (!uri) {
          throw new Error('URI SIP inválida');
        }

        this.userAgent = new UserAgent({
          uri,

          contactParams: {
  transport: 'wss',
},

          transportOptions: {
            server: `wss://${this.tempSipServer}/ws`,
          },

          authorizationUsername: this.tempExtension,
          authorizationPassword: this.tempSipPassword,

          displayName:
            this.tempAgentName || this.tempExtension,

          sessionDescriptionHandlerFactoryOptions: {
            peerConnectionConfiguration: {
              iceServers: [],
            },

            constraints: {
              audio: true,
              video: false,
            },
          },
        });

this.userAgent.delegate = {
  onInvite: invitation => {
    console.log('Chamada recebida:', invitation);

    this.currentSession = invitation;
    this.incomingCall = true;
    this.callStatus = 'incoming';
    this.incomingNumber =
      invitation.remoteIdentity?.uri?.user ||
      'Número desconhecido';

    invitation.stateChange.addListener(state => {
      if (state === SessionState.Established) {
        this.incomingCall = false;
        this.callStatus = 'connected';
        this.startCallTimer();
        this.setupRemoteMedia(invitation);
      }

      if (state === SessionState.Terminated) {
        this.stopCallTimer();
        this.incomingCall = false;
        this.incomingNumber = '';
        this.callStatus = 'idle';
        this.currentSession = null;
      }
    });
  },
};
        await this.userAgent.start();

        this.registerer = new Registerer(this.userAgent);

        this.registerer.stateChange.addListener(state => {
          console.log('Estado registro SIP:', state);

          if (state === RegistererState.Registered) {
            this.sipStatus = 'connected';

            this.extension =
              this.tempExtension.trim();

            this.agentName =
              this.tempAgentName.trim();

            this.sipServer =
              this.tempSipServer.trim();

            localStorage.setItem(
              'impulso_phone_settings',
              JSON.stringify({
                extension: this.extension,
                agentName: this.agentName,
                sipServer: this.sipServer,
              })
            );
          }

          if (
            state === RegistererState.Unregistered ||
            state === RegistererState.Terminated
          ) {
            this.sipStatus = 'disconnected';
          }
        });

        await this.registerer.register();
      } catch (error) {
        console.error('Erro SIP:', error);
        this.sipStatus = 'error';
      }
    },

    // -------------------------
    // ÁUDIO WEBRTC
    // -------------------------

    setupRemoteMedia(session) {
      const audio = this.$refs.remoteAudio;

      const peerConnection =
        session.sessionDescriptionHandler?.peerConnection;

      if (!audio || !peerConnection) {
        console.error(
          'Áudio remoto ou PeerConnection não disponível'
        );
        return;
      }

      const remoteStream = new MediaStream();

      peerConnection.getReceivers().forEach(receiver => {
        if (receiver.track) {
          remoteStream.addTrack(receiver.track);
        }
      });

      peerConnection.ontrack = event => {
        event.streams.forEach(stream => {
          stream.getTracks().forEach(track => {
            const alreadyExists = remoteStream
              .getTracks()
              .some(
                existingTrack =>
                  existingTrack.id === track.id
              );

            if (!alreadyExists) {
              remoteStream.addTrack(track);
            }
          });
        });

        audio.srcObject = remoteStream;

        audio.play().catch(error => {
          console.error(
            'Erro ao reproduzir áudio remoto:',
            error
          );
        });
      };

      audio.srcObject = remoteStream;

      audio.play().catch(error => {
        console.error(
          'Erro inicial do áudio remoto:',
          error
        );
      });
    },

    // -------------------------
    // FAZER CHAMADA
    // -------------------------

    async callNumber() {
      if (!this.phoneNumber) return;

      if (
        this.sipStatus !== 'connected' ||
        !this.userAgent
      ) {
        this.openSettings();
        return;
      }

      try {
        const number = this.phoneNumber.replace(
          /[^0-9*#]/g,
          ''
        );

        const target = UserAgent.makeURI(
          `sip:${number}@${this.sipServer}`
        );

        if (!target) {
          throw new Error('Destino SIP inválido');
        }

        const inviter = new Inviter(
          this.userAgent,
          target,
          {
          earlyMedia: true,
            sessionDescriptionHandlerOptions: {
              constraints: {
                audio: true,
                video: false,
              },
            },
          }
        );

        this.currentSession = inviter;
        this.callStatus = 'calling';

        inviter.stateChange.addListener(state => {
  console.log('Estado da chamada:', state);

  if (state === SessionState.Establishing) {
    this.callStatus = 'calling';

    setTimeout(() => {
      this.setupRemoteMedia(inviter);
    }, 300);
  }

  if (state === SessionState.Established) {
    this.callStatus = 'connected';
this.startCallTimer();
    this.setupRemoteMedia(inviter);
  }

  if (state === SessionState.Terminated) {
this.stopCallTimer();
    this.callStatus = 'idle';
    this.currentSession = null;

    if (this.$refs.remoteAudio) {
      this.$refs.remoteAudio.srcObject = null;
    }
  }
});

        await inviter.invite();
      } catch (error) {
        console.error(
          'Erro ao realizar chamada:',
          error
        );

        this.callStatus = 'idle';
        this.currentSession = null;
      }
    },

    // -------------------------
    // ENCERRAR CHAMADA
    // -------------------------

    async hangupCall() {
this.stopCallTimer();
      if (!this.currentSession) return;

      try {
        if (
          this.currentSession.state ===
          SessionState.Established
        ) {
          await this.currentSession.bye();
        } else {
          await this.currentSession.cancel();
        }
      } catch (error) {
        console.error(
          'Erro ao encerrar chamada:',
          error
        );
      }

      this.callStatus = 'idle';
      this.currentSession = null;

      if (this.$refs.remoteAudio) {
        this.$refs.remoteAudio.srcObject = null;
      }
    },
  },
};
</script>
<template>
  <div>
    <div
      v-if="voipEnabled && showDialer"
      class="impulso-dialer fixed z-[9998] w-72 p-4 bg-n-background rounded-xl shadow-2xl border border-n-weak"
      :style="{
        left: `${dialerX}px`,
        top: `${dialerY}px`,
      }"
    >
      <div
        class="flex items-center justify-between mb-4 cursor-move select-none"
        @pointerdown="onDialerPointerDown"
      >
        <div>
          <h3
            class="text-lg font-semibold text-n-slate-12"
          >
            Discador
          </h3>

          <p class="text-xs text-n-slate-11">
            Digite o número do cliente
          </p>
        </div>
<div
  v-if="incomingCall"
  class="p-4 mb-4 text-center rounded-xl bg-n-alpha-black2"
>
  <div class="mb-1 text-xs text-n-slate-11">
    Chamada recebida
  </div>

  <div class="mb-4 text-lg font-semibold text-n-slate-12">
    📞 {{ incomingNumber }}
  </div>

  <div class="flex gap-2">
    <button
      type="button"
      class="w-1/2 py-3 font-semibold text-white bg-red-600 rounded-lg"
      @click="rejectIncomingCall"
    >
      Recusar
    </button>

    <button
      type="button"
      class="w-1/2 py-3 font-semibold text-white rounded-lg bg-n-brand"
      @click="answerIncomingCall"
    >
      Atender
    </button>
  </div>
</div>
        <div class="flex items-center gap-3">
        

          <button
            type="button"
            title="Fechar"
            class="text-xl text-n-slate-11 hover:text-n-slate-12"
            @pointerdown.stop
            @click="closeDialer"
          >
            ×
          </button>
        </div>
      </div>

      <template v-if="!showSettings">
        <div class="flex items-center gap-2 mb-4">
          <input
            v-model="phoneNumber"
            type="text"
            inputmode="tel"
            placeholder="+55 (__) _____-____"
            class="w-full px-3 py-3 text-lg text-center rounded-lg border border-n-weak bg-n-alpha-black2 text-n-slate-12"
            @keyup.enter="callNumber"
          />

          <button
            type="button"
            title="Apagar"
            class="px-3 py-3 rounded-lg bg-n-alpha-black2 text-n-slate-12"
            @click="deleteDigit"
          >
            ⌫
          </button>
        </div>

        <div class="grid grid-cols-3 gap-3 mb-4">
          <button
            v-for="digit in [
              '1','2','3',
              '4','5','6',
              '7','8','9',
              '*','0','#'
            ]"
            :key="digit"
            type="button"
            class="h-12 text-lg font-medium rounded-lg bg-n-alpha-black2 hover:bg-n-alpha-black3 text-n-slate-12"
            @click="addDigit(digit)"
          >
            {{ digit }}
          </button>
        </div>

        <div class="flex gap-2">
          <button
            type="button"
            class="w-1/3 py-3 rounded-lg bg-n-alpha-black2 text-n-slate-12"
            @click="clearNumber"
          >
            Limpar
          </button>

          <button
            v-if="!currentSession"
            type="button"
            class="w-2/3 py-3 font-semibold text-white rounded-lg bg-n-brand hover:opacity-90"
            @click="callNumber"
          >
            📞 Ligar
          </button>

          <button
            v-else
            type="button"
            class="w-2/3 py-3 font-semibold text-white bg-red-600 rounded-lg hover:opacity-90"
            @click="hangupCall"
          >
            🔴 Encerrar
          </button>
        </div>

        <div
  v-if="currentSession"
  class="mt-3 text-sm font-medium text-center text-n-slate-12"
>
  <template v-if="callStatus === 'connected'">
    Em chamada • {{ formatDuration(callDuration) }}
  </template>

  <template v-else>
    {{ callStatusLabel }}
  </template>
</div>

        <div
          class="mt-3 text-xs text-center text-n-slate-11"
        >
          <template v-if="extension">
            Ramal {{ extension }}

            <template v-if="agentName">
              • {{ agentName }}
            </template>

            • {{ sipStatusSymbol }}
            {{ sipStatusLabel }}
          </template>

          <template v-else>
            ⚠️ Ramal não configurado
          </template>
        </div>
      </template>

      <template v-else>
        <div class="space-y-4">
          <div>
            <label
              class="block mb-1 text-xs font-medium text-n-slate-11"
            >
              Ramal
            </label>

            <input
              v-model="tempExtension"
              type="text"
              inputmode="numeric"
              placeholder="Ex.: 301"
              class="w-full px-3 py-3 rounded-lg border border-n-weak bg-n-alpha-black2 text-n-slate-12"
            />
          </div>

          <div>
            <label
              class="block mb-1 text-xs font-medium text-n-slate-11"
            >
              Nome do atendente
            </label>

            <input
              v-model="tempAgentName"
              type="text"
              placeholder="Ex.: Diego"
              class="w-full px-3 py-3 rounded-lg border border-n-weak bg-n-alpha-black2 text-n-slate-12"
            />
          </div>

          <div>
            <label
              class="block mb-1 text-xs font-medium text-n-slate-11"
            >
              Servidor SIP
            </label>

            <input
              v-model="tempSipServer"
              type="text"
              placeholder="pbx.impulsotelecom.com.br"
              class="w-full px-3 py-3 rounded-lg border border-n-weak bg-n-alpha-black2 text-n-slate-12"
            />
          </div>

          <div>
            <label
              class="block mb-1 text-xs font-medium text-n-slate-11"
            >
              Senha SIP
            </label>

            <input
              v-model="tempSipPassword"
              type="password"
              autocomplete="new-password"
              placeholder="Senha do ramal"
              class="w-full px-3 py-3 rounded-lg border border-n-weak bg-n-alpha-black2 text-n-slate-12"
            />
          </div>

          <div
            class="p-3 text-xs rounded-lg bg-n-alpha-black2 text-n-slate-11"
          >
            Status:
            {{ sipStatusSymbol }}
            {{ sipStatusLabel }}
          </div>

          <button
            type="button"
            class="w-full py-3 font-semibold text-white rounded-lg bg-n-brand hover:opacity-90"
            @click="connectSip"
          >
            Conectar ramal
          </button>

          <div class="flex gap-2">
            <button
              type="button"
              class="w-1/2 py-3 rounded-lg bg-n-alpha-black2 text-n-slate-12"
              @click="closeSettings"
            >
              Cancelar
            </button>

            <button
              type="button"
              class="w-1/2 py-3 font-semibold text-white rounded-lg bg-n-brand hover:opacity-90"
              @click="saveSettings"
            >
              Salvar
            </button>
          </div>
        </div>
      </template>
    </div>
     

    <!-- POPUP DE CHAMADA RECEBIDA -->
    <div
      v-if="voipEnabled && incomingCall && !showDialer"
      class="fixed z-[10000] w-72 p-5 text-center rounded-2xl border border-n-weak bg-n-background shadow-2xl"
      :style="{
        left: '50%',
        top: '90px',
        transform: 'translateX(-50%)',
      }"
    >
      <div class="mb-2 text-sm text-n-slate-11">
        Chamada recebida
      </div>

      <div class="mb-5 text-2xl font-semibold text-n-slate-12">
        📞 {{ incomingNumber }}
      </div>

      <div class="flex gap-3">
        <button
          type="button"
          class="w-1/2 py-3 font-semibold text-white bg-red-600 rounded-xl"
          @click="rejectIncomingCall"
        >
          Recusar
        </button>

        <button
          type="button"
          class="w-1/2 py-3 font-semibold text-white bg-green-600 rounded-xl"
          @click="answerIncomingCall"
        >
          Atender
        </button>
      </div>
    </div>

<button
  v-if="voipEnabled && !showDialer"
  type="button"
  title="Abrir discador"
  aria-label="Abrir discador"
  :style="{
    left: `${x}px`,
    top: '2px',
    background: 'linear-gradient(145deg, #22c55e, #16a34a)',
    boxShadow:
      '0 0 0 3px rgba(34,197,94,0.30), 0 0 25px rgba(34,197,94,0.55), 0 8px 24px rgba(0,0,0,0.40)',
  }"
  class="fixed z-[9999] flex items-center justify-center w-14 h-14 text-white rounded-full cursor-grab active:cursor-grabbing select-none touch-none transition-transform duration-200 hover:scale-110"
  @pointerdown="onPointerDown"
  @click="openDialer"
>
  <!-- Base presa no topo -->
  <span
    class="absolute pointer-events-none"
    :style="{
width: '86px',
height: '34px',
left: '50%',
top: '-18px',
      transform: 'translateX(-50%)',
      background:
        'linear-gradient(180deg, rgba(34,197,94,0.50), rgba(22,163,74,0.12))',
clipPath:
  'polygon(12% 0, 88% 0, 68% 100%, 32% 100%)',
      filter: 'drop-shadow(0 5px 10px rgba(34,197,94,0.25))',
    }"
  ></span>

  <!-- Aro externo -->
  <span
    class="absolute inset-[-6px] rounded-full pointer-events-none"
    :style="{
      border: '2px solid rgba(34,197,94,0.70)',
      boxShadow: '0 0 14px rgba(34,197,94,0.45)',
    }"
  ></span>

  <!-- Aro interno -->
  <span
    class="absolute inset-[3px] rounded-full pointer-events-none"
    :style="{
      border: '1px solid rgba(255,255,255,0.18)',
    }"
  ></span>

  <!-- Telefone -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    class="relative z-10 w-7 h-7"
  >
    <path
      fill-rule="evenodd"
      d="M1.5 4.5A3 3 0 0 1 4.5 1.5h1.372c.86 0 1.61.586 1.819 1.42l.738 2.953a1.875 1.875 0 0 1-.694 1.956l-1.293.97a11.042 11.042 0 0 0 4.759 4.759l.97-1.293a1.875 1.875 0 0 1 1.956-.694l2.953.738a1.875 1.875 0 0 1 1.42 1.819V15.5a3 3 0 0 1-3 3h-.75C7.432 18.5 1.5 12.568 1.5 5.25V4.5Z"
      clip-rule="evenodd"
    />
  </svg>
</button>
    <audio
      ref="remoteAudio"
      autoplay
      playsinline
    ></audio>
  </div>
</template>
